let hostname = process.env.REACT_APP_API_URL;
export const API_URL = hostname + "/api/v1/";
